const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsClientes = { name: 'Clientes', pathName: null, action: 'clientes' }

export default [
  {
    path: '/v3/clientes',
    name: 'Clientes',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'perfil-demografico',
        name: 'perfil-demografico',
        component: () => import('@/modules/clientes/perfil-demografico/views/pages/PerfilDemografico.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Perfil demográfico',
              pathName: null,
            },
          ],
          title: 'Perfil demográfico',
          // Mesma permissão da rota do v2 (`clientes/perfil_demografico`). Permissão perdida na
          // migração é incidente de segurança, não detalhe de UI.
          requiredUserPermissions: ['clientes/perfil_demografico'],
        },
      },
      {
        path: 'mapa',
        name: 'mapa',
        component: () => import('@/modules/clientes/mapa/views/pages/Mapa.vue'),
        meta: {
          // O v2 não declara breadcrumb nesta rota (o meta tem só `title` e `pagePermission`), e a
          // tela é full-bleed: manter sem breadcrumb preserva a altura útil do mapa.
          title: 'Mapa',
          // Mesma permissão da rota do v2 (`clientes/mapa`). Permissão perdida na migração é
          // incidente de segurança, não detalhe de UI.
          requiredUserPermissions: ['clientes/mapa'],
        },
      },
      {
        path: 'consultar-ofertas',
        name: 'consultar-ofertas',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarOfertas.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: null,
            },
          ],
          title: 'Consultar Benefícios',
          requiredUserPermissions: ['clientes/consultar-ofertas'],
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'melhores-clientes',
        name: 'melhores-clientes',
        component: () => import('@/modules/clientes/melhores-clientes/views/pages/MelhoresClientes.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Melhores clientes',
              pathName: null,
            },
          ],
          title: 'Melhores clientes',
          requiredUserPermissions: ['clientes/melhores_clientes'],
        },
      },
      {
        path: 'retencao',
        name: 'retencao',
        component: () => import('@/modules/clientes/retencao/views/pages/Retention.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsClientes, { name: 'Retenção', pathName: null }],
          title: 'Retenção',
          // Mesma permissão da rota do v2 (`clientes/retencao`). Permissão perdida na migração é
          // incidente de segurança, não detalhe de UI.
          requiredUserPermissions: ['clientes/retencao'],
        },
      },
      {
        path: 'interesses',
        redirect: { name: 'interesses-por-genero' },
      },
      {
        path: 'interesses/por-genero',
        name: 'interesses-por-genero',
        component: () => import('@/modules/clientes/interesses/views/pages/Interesses.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsClientes, { name: 'Interesses', pathName: null }],
          title: 'Interesses por gênero',
          requiredUserPermissions: ['clientes/interesses/genero'],
        },
      },
      {
        path: 'interesses/por-idade',
        name: 'interesses-por-idade',
        component: () => import('@/modules/clientes/interesses/views/pages/Interesses.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsClientes, { name: 'Interesses', pathName: null }],
          title: 'Interesses por idade',
          requiredUserPermissions: ['clientes/interesses/idade'],
        },
      },
      {
        path: 'interesses/pessoa-juridica',
        name: 'interesses-pessoa-juridica',
        component: () => import('@/modules/clientes/interesses/views/pages/Interesses.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsClientes, { name: 'Interesses', pathName: null }],
          title: 'Interesses pessoa jurídica',
          requiredUserPermissions: ['clientes/interesses/pessoa_juridica'],
        },
      },
    ],
  },
]
